import React, { type ReactElement } from 'react';

import SearchBox from '@/common/components/input/search-box.component';

interface Props {
  onSearch: (query: string) => void;
  className?: string;
  placeholder?: string;
}

function ProductSearch({
  onSearch,
  className = '',
  placeholder,
}: Props): ReactElement {
  const handleSearch = (query: string) => {
    onSearch(query);
  };
  return (
    <div className={`my-2 ${className}`}>
      <SearchBox
        placeholder={placeholder || 'جستجو در میان محصولات فروشگاه'}
        onSearch={handleSearch}
      />
    </div>
  );
}

export default ProductSearch;
